// PE-6155 — HttpContext flag to skip the global HTTP error toast (custom UX handlers)
import { HttpContextToken } from '@angular/common/http';

/**
 * When true, connectionErrorInterceptor will not toast.
 * Use for flows that map errors themselves (e.g. sign-in credentials messaging).
 */
export const SKIP_HTTP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
